import React from "react";
import { MessageCircle } from "lucide-react";
import { useApp } from "@/contexts/AppContext";

export const WhatsAppFab = () => {
  const { settings, tr } = useApp();
  const link = `https://wa.me/${settings.whatsapp_sales}?text=${encodeURIComponent(tr.whatsappMsgs.general)}`;
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 end-6 z-40 bg-[#25D366] hover:bg-[#1EBE57] text-white p-4 rounded-full shadow-[0_8px_32px_rgba(37,211,102,0.35)] hover:scale-105 transition-transform"
      aria-label="WhatsApp"
      data-testid="whatsapp-fab"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
};
